export interface CapturedComment {
  commentId: string;
  authorName: string;
  profileUrl: string;
  message: string;
  permalink: string;
}

function facebookUrl(value: unknown): URL | null {
  if (typeof value !== "string") return null;
  try {
    const url = new URL(value);
    if (url.protocol !== "https:" ||
        !(url.hostname === "facebook.com" || url.hostname.endsWith(".facebook.com"))) return null;
    return url;
  } catch { return null; }
}

export function parseCapturedComments(json: string): CapturedComment[] {
  const input: unknown = JSON.parse(json);
  if (!Array.isArray(input) || input.length > 1000) throw new Error("Paste a JSON list with at most 1000 comments.");
  const byId = new Map<string, CapturedComment>();
  for (const item of input) {
    if (typeof item !== "object" || item === null) throw new Error("Invalid comment record.");
    const value = item as Record<string, unknown>;
    const { commentId, authorName, message } = value;
    const profile = facebookUrl(value.profileUrl);
    const permalink = facebookUrl(value.permalink);
    if (typeof commentId !== "string" || !/^\d+_\d+$/.test(commentId) ||
        typeof authorName !== "string" || !authorName.trim() || authorName.length > 200 ||
        typeof message !== "string" || !message.trim() || message.length > 10000 ||
        !profile || !permalink) throw new Error("Invalid captured comment fields.");
    const [videoId, shortId] = commentId.split("_");
    if (!new RegExp(`/videos/${videoId}/?$`).test(permalink.pathname) ||
        permalink.searchParams.get("comment_id") !== shortId) {
      throw new Error("Mã bình luận không khớp với liên kết Facebook.");
    }
    const record: CapturedComment = {
      commentId, authorName: authorName.trim(), profileUrl: profile.href,
      message: message.trim(), permalink: permalink.href
    };
    const previous = byId.get(commentId);
    if (previous && (previous.authorName !== record.authorName || previous.message !== record.message ||
        previous.profileUrl !== record.profileUrl)) throw new Error("Có nhiều dòng xung đột cho cùng một mã bình luận.");
    byId.set(commentId, record);
  }
  return [...byId.values()];
}
